// extracted by mini-css-extract-plugin
module.exports = {"Features":"features-module--Features--vgt8O"};